module.exports = __webpack_public_path__ + "06_bob_black.01782b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_bob_black.png
// module id = Junb
// module chunks = 0